// Chat configuration for optimizing API calls
export const chatConfig = {
  // Enable/disable polling when WebSocket is connected
  enablePollingWhenWebSocketConnected: false,

  // Polling intervals (in milliseconds)
  // Note: messages and unreadCount use WebSocket for real-time updates
  pollingIntervals: {
    messages: false,        // ✅ Disabled - WebSocket handles real-time message updates
    conversations: 60000,   // ✅ Keep - Used for conversations list (no WebSocket event)
    unreadCount: false,     // ✅ Disabled - WebSocket handles unread count updates
  },

  // WebSocket configuration
  websocket: {
    enabled: true,
    reconnectInterval: 5000,
    maxReconnectAttempts: 5,
  },

  // Cache settings
  cache: {
    staleTime: 30000,       // 30 seconds
    cacheTime: 300000,      // 5 minutes
  },

  // Rate limiting
  rateLimit: {
    maxRequestsPerMinute: 60,
    burstLimit: 10,
  }
};

export default chatConfig;